import * as React from 'react';
import { FooterQuery, Maybe, MetaTagsFieldsFragment, NavbarQuery } from 'types/generated';
import Navbar from './Syn/Navbar';
import clsx from 'clsx';
import { fullScreenChildGridClasses } from '@/styles/grid';
import Footer from './Footer';
import Head from 'next/head';
import MetaTags from './MetaTags';
import { useIsLarge } from '@/utils/hooks';
import { getOr } from '@/utils/options';
import { useSearchParams } from 'next/navigation';
import Popup from 'components/src/popup';
import { RadioSchedule } from '@/models/RadioTypes';
import { useHydrateAtoms } from 'jotai/react/utils';
import { scheduleAtom } from '../store';

type Props = {
  title: string;
  metaTags: MetaTagsFieldsFragment | null | undefined;
  contactFormSetting?: Maybe<string>;
  footer: FooterQuery;
  navbar: NavbarQuery;
  radioSchedules: Record<string, RadioSchedule[]>;
  children?: React.ReactNode;
};

const PageContainer = ({ title, metaTags, contactFormSetting, footer, navbar, radioSchedules, children }: Props) => {
  useHydrateAtoms([[scheduleAtom, radioSchedules]]);
  const [openDropdownTitle, setOpenDropdownTitle] = React.useState<string | null | undefined>();
  const mainFooterData = footer.footerCollection?.items?.[0];
  const mainNavbarData = navbar.navbarCollection?.items?.[0];
  const isLarge = useIsLarge();
  const isBgBlurred = Boolean(openDropdownTitle) && isLarge;
  const searchParams = useSearchParams();
  const [showThankYouModal, setShowThankYouModal] = React.useState<boolean>(false);

  const handleThankYouModalClose = () => {
    setShowThankYouModal(false);
  };

  React.useEffect(() => {
    if (searchParams.get('komdu-i-vidskipti') === 'true') {
      setShowThankYouModal(true);
    }
  }, [searchParams]);

  return (
    <>
      <Head>
        <title>{getOr(title, 'Sýn')}</title>
        {metaTags && <MetaTags metaTags={metaTags} />}
      </Head>
      {mainNavbarData && (
        <Navbar
          navbar={mainNavbarData}
          openDropdownTitle={openDropdownTitle}
          onSetOpenDropdownTitle={setOpenDropdownTitle}
          contactFormSetting={contactFormSetting}
        />
      )}
      <div className={clsx(fullScreenChildGridClasses, 'mt-20 lg:mt-30 filter-none transition-filter')}>
        {isBgBlurred && (
          <div id="blurContent" className="fixed z-[99] h-full w-full backdrop-blur-md transition-filter" />
        )}
        {children}
        {mainFooterData && <Footer data={mainFooterData} />}
      </div>
      <Popup
        isOpen={showThankYouModal}
        title={'Takk fyrir'}
        text={'Við höfum móttekið fyrirspurnina og munum svara henni eins fljótt og auðið er.'}
        buttonText={'Loka glugga'}
        variant={'content'}
        onClose={handleThankYouModalClose}
        onClick={handleThankYouModalClose}
      />
    </>
  );
};
export default PageContainer;
